"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _decoration = require("@/api/decoration");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DecorationSiteBasic',
  data: function data() {
    return {
      loading: false,
      list: []
    };
  },
  created: function created() {
    this.reload();
  },
  methods: {
    reload: function reload() {
      var _this = this;
      this.loading = true;
      (0, _decoration.decorationSiteBasicListApi)({
        page: 1,
        limit: 50
      }).then(function (data) {
        _this.list = data.list || [];
      }).finally(function () {
        _this.loading = false;
      });
    },
    openEdit: function openEdit(row) {
      var _this2 = this;
      this.$prompt('工地备注', '完善基础信息', {
        inputValue: row.project.remark || 'E2E完善备注'
      }).then(function (_ref) {
        var value = _ref.value;
        (0, _decoration.decorationSiteBasicUpdateApi)(row.project.id, {
          projectName: row.project.projectName,
          addressDetail: row.project.addressDetail && row.project.addressDetail.length >= 6 ? row.project.addressDetail : "".concat(row.project.addressDetail || '', "\u8BE6\u7EC6\u65BD\u5DE5\u5730\u5740"),
          plannedStartDate: String(row.project.plannedStartDate || '').slice(0, 10),
          plannedEndDate: String(row.project.plannedEndDate || '').slice(0, 10),
          remark: value || 'E2E完善备注'
        }).then(function () {
          _this2.$message.success('已保存');
          _this2.reload();
        });
      }).catch(function () {});
    }
  }
};